export class Actualizacion {


  constructor(
    ) {}
  }
